import React, { Component } from 'react'
import Button from '../../Components/Button'
import RoundCard from '../../Components/RoundCard'
import './ListingCard.scss'

export default class ListingCard extends Component {
    render() {
        let { item } = this.props

        return (
            <RoundCard scaleOnHover={false} className='listing-card-container'>
                <h2 className="listing-title">{item.listingTitle}</h2>
                <div className="session-price">
                    {`Available at `}
                    <span>{`₹${item.sessionPrice}`}</span>
                    {` per session.`}
                </div>
                <div className="description">
                    <h3>Description</h3>
                    <p>{item.listingDescription}</p>
                </div>
                <div className="location">{`Located at ${item.city}`}</div>
                <div className="package-info">{item.packageInformation}</div>
                <div className="package-price">
                    <span>Package Price:</span>
                    <span>{` ₹${item.packagePrice}`}</span>
                </div>
                <div className="slots">
                    <div className="key">Slots:</div>
                    {
                        item.slots.split(',').map((slot, idx) => (
                            <div key={idx} className="slot">{slot}</div>
                        ))
                    }
                </div>
                <Button className={'enroll-btn'} variant={'primary-light'}>Enroll Now</Button>
            </RoundCard>
        )
    }
}
